export const profileTabs = ["account", "general", "changePassword"] as const;

export type profileTabsValue = (typeof profileTabs)[number];
